import React from 'react';
import aboutHeroImage from '../assets/about.jpg';

function Hero() {
  return (
    <div className="w-full h-screen">
      <img
        className="top-0 left-0 w-full h-screen object-cover"
        src={aboutHeroImage}
        alt=""
      />
      <div className="bg-black/70 absolute top-0 left-0 w-full h-screen" />
      <div className="absolute top-0 w-full h-full flex flex-col justify-center text-white">
        <div class="container py-16 mx-auto text-center">
          <div class=" ">
            <h1 class="text-3xl font-semibold mx-auto text-white lg:text-4xl">
              "Providing employment is the most effective way to integrate
              <br /> immigrants into our community"
            </h1>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Hero;
